import { createInertiaApp } from "@inertiajs/react"
import { createRoot } from "react-dom/client"
import { InertiaFlash } from "@/components/InertiaFlash"
import type { FlashData } from "@/types"

void createInertiaApp({
  pages: "../pages",

  strictMode: true,

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: "brackets" }
    },
  },
}).catch((error) => {
  // This ensures this entrypoint is only loaded on Inertia pages
  // by checking for the presence of the root element (#app by default).
  // Feel free to remove this `catch` if you don't need it.
  if (document.getElementById("app")) {
    throw error
  } else {
    console.error(
      "Missing root element.\n\n" +
        "If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.\n" +
        'Consider moving <%= vite_typescript_tag "inertia.tsx" %> to the Inertia-specific layout instead.',
    )
  }
})

// A layout that hosts Inertia pages renders an empty #inertia-flash slot instead of its own ERB
// flash banner; the banner lives here so it updates on every Inertia visit.
function initialPageFlash(): FlashData {
  try {
    const pageJson = document.querySelector(
      'script[data-page="app"]',
    )?.textContent
    return (pageJson ? JSON.parse(pageJson).flash : null) ?? {}
  } catch {
    return {}
  }
}

function mountFlash() {
  const el = document.getElementById("inertia-flash")
  if (!el) return

  createRoot(el).render(<InertiaFlash initialFlash={initialPageFlash()} />)
}

mountFlash()
